import Model from './Model'
import LabelPresenter from '../helpers/LabelPresenter'

class Job extends Model {
    constructor (attributes) {
        super(attributes)

        if (this.members === undefined) {
            this.members = []
        }

        this.sortLabels()
    }

    addMember (member) {
        this.members.push(member)
    }

    removeMember (memberId) {
        this.members = this.members.filter(member => member.id !== memberId)
    }

    addLabel (label) {
        this.labels.push(label)
        this.sortLabels()
    }

    updateLabel (updatedLabel) {
        const index = this.labels.findIndex(label => label.id === updatedLabel.id)

        if (index !== -1) {
            this.labels.splice(index, 1, updatedLabel)
            this.sortLabels()
        }
    }

    removeLabel (labelId) {
        this.labels = this.labels.filter(label => label.id !== labelId)
    }

    sortLabels () {
        this.labels = LabelPresenter.present(this.labels)
    }
}

export default Job
